import React from "react";
import Navbar from "../components/navbar";
import Login from "../components/login";

const LoginPage = () => {
    return (
        <div>
            <Navbar />
            <Login />
        </div>
    );
}

export default LoginPage;